import React from 'react';
import { CollegeBioCardFragment, CollegeDetailsFragment } from '../../../generated/spin-graphql';
import { Biography } from '../../profiles/Biography';
import { CollegeProfileInfo } from './CollegeProfileInfo';
import { gql } from '@urql/core';

type Props = {
    college: CollegeBioCardFragment;
};

gql`
    fragment CollegeBioCard on espin_college {
        bio
        contact_email
        phone
        ...CollegeProfileInfo
    }
`;

export const CollegeBioCard: React.FC<Props> = ({ college }) => {
    return (
        <div className="college-bio-container">
            <CollegeProfileInfo college={college} />

            {college.bio && <Biography biography={college.bio} />}
        </div>
    );
};
